// @ts-ignore
import React from "react";

import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives/responsive";
import FeatureGates from "@atlassian/feature-gate-js-client";
import UFOSegment from "@atlassian/wac-ufo-segment";

import { AiDeeplinkBanner } from "@/patterns/wpl/ad-banner/src";
import { UnleashBanner } from "@/patterns/wpl/ad-banner/src";
import { GovTeamTourBanner } from "@/patterns/wpl/ad-banner/src/gov-fy24-team-tour-banner";
import { TeamBanner } from "@/patterns/wpl/ad-banner/src/team-banner";

const unleashBannerWrapperStyles = css({
    display: "flex",
    justifyContent: "center",
    marginBlockEnd: "64px",
    marginBlockStart: "-64px",
    [media.above.sm]: {
        marginBlockStart: "-200px"
    }
});

export const LiftedBanner = () => {
    const govGate: boolean = FeatureGates.checkGate(
        "wac-uip-gov-fy24-team-tour-lifted-bar"
    );
    const aiGate: boolean = FeatureGates.checkGate("gwp-457-ai-deeplink-gate");
    const unleashGate: boolean = FeatureGates.checkGate(
        "wac-lifted-bar-atlassian-presents-unleash"
    );
    const teamBannerGate = FeatureGates.getExperimentValue(
        "wac-lifted-bar-team-24",
        "ShowButterBar",
        true
    );

    if (teamBannerGate) {
        return (
            <UFOSegment name="aideeplink-lifted-banner">
                <div css={unleashBannerWrapperStyles}>
                    <TeamBanner />
                </div>
            </UFOSegment>
        );
    }

    if (govGate) {
        return (
            <UFOSegment name="govteamtour-lifted-banner">
                <div css={unleashBannerWrapperStyles}>
                    <GovTeamTourBanner />
                </div>
            </UFOSegment>
        );
    }

    if (unleashGate) {
        return (
            <UFOSegment name="unleash-lifted-banner">
                <div css={unleashBannerWrapperStyles}>
                    <UnleashBanner />
                </div>
            </UFOSegment>
        );
    }

    if (aiGate) {
        return (
            <UFOSegment name="aideeplink-lifted-banner">
                <div css={unleashBannerWrapperStyles}>
                    <AiDeeplinkBanner />
                </div>
            </UFOSegment>
        );
    }
    return null;
};
